import React, { useRef, useState, useCallback, useEffect } from "react";
import { useQuery, useMutation } from "react-query";
import * as PR from "../../prime-modules/index";
import { hasAnyPermission, hasPermission, MODIFY_VOUCHER_MASK, PERMISSIONS, serializeParams } from "../../utils/reuse";
import "./index.scss";
import {
  filterCountryName,
  setDataAmount,
  formatPromoCode,
  getCurrentTimestamp,
} from "../../utils/reuse";
import moment from "moment";
import {
  getBatchList,
  getBatchInfo,
  getCountries,
  getBatchStatus,
  getVoucherStatus,
  shareEmail
} from "../../services/affiliateApi";
import CreatePrepaidVoucher from "./CreatePrepaidVoucher";
import RoamingColumn from "./RoamingInfo.jsx";
import { useSelector } from "react-redux";
import { getCurrencySymbol, globalConfig } from "../../constants.js";

const PrepaidVouchers = () => {
  const toast = useRef(null);
  const timeStamp = getCurrentTimestamp();
  const [expandedRows, setExpandedRows] = useState([]);
  const [visible, setVisible] = useState(false);
  const [filterVisible, setFilterVisible] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [getBatchName, setGetBatchName] = useState("");
  const [getStatus, setGetStatus] = useState("");
  const [filters, setFilters] = useState({});
  const { afUserData } = useSelector((state) => state.afAuth);
  const [shareVoucher, setShareVoucher] = useState(false);
  const [voucherCode, setVoucherCode] = useState({code: "", id:""});
  const [offset, setOffset] = useState(0);
  const itemsPerPage = 10;
  const [sortField, setSortField] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [totalRecords, setTotalRecords] = useState(0);
  const [prepaidList, setPrepaidList] = useState([]);
  const [batchOptions, setBatchOptions] = useState([]);
  const [showBatchInfoDialog, setShowBatchInfoDialog] = useState(false);
  const [disableText, setDisableText] = useState("");
  const [disable, setDisable] = useState(false);
  const [filterSelectedRegion, setFilterSelectedRegion] = useState(null);
  const [filterCountries, setFilterCountries] = useState([]);
  const [filterCountry, setFilterCountry] = useState("GB");
  const [allCountries, setAllCountries] = useState([]);
  const [uniqueRegions, setUniqueRegions] = useState([]);
  const [filterprovider, setFilterProvider] = useState("");
  const [filterBatchName, setFilterBatchName] = useState(null);
  const [filterStatus, setFilterStatus] = useState("");
  const [filterApplyStatus, setFilterApplyStatus] = useState(false)
  const [searchFilterApply, setSearchFilterApply] = useState(false)
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [batchData, setBatchData] = useState([]);
  const latestReqRef = useRef(null);
  const { affiliate, labels } = useSelector(state => state.language?.activelang);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [filterCount, setFilterCount] = useState(0);
  const [vouchers, setVouchers] = useState([]);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const optionStatusList = [
    { label: "ACTIVE", value: "ACTIVE" },
    { label: "PENDING", value: "PENDING" },
    { label: "EXPIRED", value: "EXPIRED" },
    { label: "REDEEMED", value: "USED" },
    { label: "RESERVED", value: "RESERVED" },
  ];
  const userRolePermission = afUserData?.permission;
  const modifyVoucherManagement = hasAnyPermission(userRolePermission, MODIFY_VOUCHER_MASK);
  const createVoucherPermission = hasPermission(userRolePermission, PERMISSIONS.CREATE_VOUCHERS);
  const seeUsers = hasAnyPermission(userRolePermission, PERMISSIONS.SEE_USERS);

  const batchName = (rowData) => {
    return (
      <div className="batch-column" onClick={(e) => e.stopPropagation()}>
        <div className="card flex align-items-center gap-3">
          <p>{rowData?.batchName} </p>
        </div>
      </div>
    );
  };

  const getSearchHandler = useCallback(() => {
    const searchStatus = getStatus?.length ? getStatus.join(",") : null;
    setOffset(0);
    setFirst(0);
    setRows(10);
    setFilters((prevFilters) => ({
      ...prevFilters,
      batchId: getBatchName,
      status: searchStatus,
      keyword: searchValue.trim()
    }));
    setSearchFilterApply(true)
  }, [getBatchName, getStatus, searchValue]);

  const getResetHandler = () => {
    setGetBatchName("");
    setGetStatus("");
    setSearchValue("");
    if (searchFilterApply) {
      setSearchFilterApply(false)
      setFilters(state => ({ ...state, batchId: null, batchName: null, status: null, keyword: "" }));

    }
  };

  const copyToClipboard = (voucherCode, showToast) => {
    navigator.clipboard.writeText(voucherCode);
    if (showToast) {
      toast.current.show({
        severity: "success",
        summary: "Copied",
        detail: `Voucher code copied to clipboard!`,
        life: globalConfig?.toastDisplayTime,
      });
    }
  };

  const flattenBundles = (list) => {
    return list.map((batch) => ({
      batchName: batch?.name, // Batch name
      id: batch?.bundles.map((bundles) => bundles?.bundle.id),
      redeemed: batch?.redeemed,
      total: batch?.total,
      createdAt: batch?.createdAt,
      description: batch?.bundles.map(
        (bundles) => bundles?.bundle?.description
      ),
      providerid: batch?.bundles.map((bundles) => bundles?.bundle?.providerid),
      duration: batch?.bundles.map((bundles) => bundles?.bundle?.duration),
      dataAmount: batch?.bundles.map((bundles) => bundles?.bundle?.dataAmount),
      ourPrice: batch?.bundles.map((bundles) => bundles?.bundle?.ourPrice),
      reserved: batch?.reserved,
      disabled: batch?.disabled,
      // status: batch?.status,
      vouchers: batch?.bundles?.flatMap((bundle) =>
        bundle?.vouchers.map((i) => ({
          ...i,
          name: bundle?.bundle?.name,
          description: bundle?.bundle?.description,
          ourPrice: bundle?.bundle?.ourPrice,
          dataAmount: bundle?.bundle?.dataAmount,
          duration: bundle?.bundle?.duration,
          providerName: bundle?.providerName,
          providerid: bundle?.bundle?.providerid,
        }))
      ), // Keep vouchers for expansion
      promoCode: batch?.bundles[0]?.vouchers?.[0]?.promoCode || "N/A",
    }));
  };

  const flattenedList = flattenBundles(prepaidList);

  useEffect(() => {
    if (prepaidList && prepaidList.length > 0) {
      const flattenedList = flattenBundles(prepaidList);
      setVouchers(flattenedList);
    }
  }, [prepaidList]);

  const action = (rowData) => {
    const isDisabled = rowData.disabled !== 0;
    const isDisabledBatch = rowData.disabled !== 0 || rowData?.redeemed > 0;
    const exportDisabled = rowData.vouchers.length < 1
    return (
      <div
        className="flex gap-2 action-td"
        onClick={(e) => e.stopPropagation()}
      >
        {(createVoucherPermission) &&
          <span
            className={`hourglass ${rowData?.reserved === rowData?.total ? "active" : ""} ${isDisabledBatch ? "redeemed" : ""}`}
            onClick={() => !isDisabledBatch && handleReserveBatch(rowData, "reserve", "res")}
            style={{ cursor: isDisabledBatch ? "not-allowed" : "pointer" }}
            title={isDisabledBatch ? "Disabled" : rowData?.reserved === rowData?.total ? "Unreserve Batch" : "Reserve Batch"}
          >
            <i className="pi pi-hourglass"></i>
          </span>
        }
        <span className={`action-icon file ${(isDisabled || exportDisabled) ? "disabled-icon" : ""}`}
          onClick={() => {
            if (!isDisabled && !exportDisabled) {
              handleExportCSV(rowData);
            }
          }}
          title={isDisabled ? "Disabled" : "Download CSV"} style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}>
          <i className="pi pi-file"></i>
          <i className="pi pi-arrow-down"></i>
        </span>
        <span className={`action-icon ${isDisabled ? "disabled-icon" : ""} `}
          onClick={() => !isDisabled && handleBatchInfoClick(rowData)}
          title={isDisabled ? "Disabled" : "Batch Info"}
          style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}>
          <i className="pi pi-info-circle"></i>
        </span>
      </div>
    );
  };

  const expandAction = (rowData) => {
    const disableCode = rowData?.vouchersnapshot?.status === "RESERVED";
    const isReserved = rowData?.vouchersnapshot?.reserved;
    const isRedeemed = rowData?.vouchersnapshot?.status === "USED"
    return (
      <div
        className="flex gap-2 action-td"
        onClick={(e) => e.stopPropagation()}
      >
        <span
          className={`hourglass ${isReserved ? "active" : ""} ${isRedeemed ? "redeemed" : ""}`}
          style={{ cursor: "pointer" }}
          onClick={() => {
            if (rowData?.vouchersnapshot?.status !== 'USED') {
              handleReserveVoucher(rowData, "reserve");
              copyToClipboard(
                formatPromoCode(rowData?.vouchersnapshot?.promoCode),
                false
              );
            }
          }}
          title={
            rowData?.vouchersnapshot?.status !== 'USED'
              ? rowData?.vouchersnapshot?.reserved
                ? "Unreserve Voucher"
                : "Reserve Voucher"
              : null
          }
        >
          <i className="pi pi-hourglass"></i>
        </span>

        {disableCode ? (
          <i
            className="pi pi-copy"
            style={{
              color: "gray",
              cursor: "default"
            }}
            onClick={() => { }}
          />
        ) : (
          <i
            title="Copy Voucher Code"
            className="pi pi-copy"
            onClick={() =>
              copyToClipboard(
                formatPromoCode(
                  rowData?.vouchersnapshot?.promoCode
                ),
                true
              )
            }
          />
        )}
        {rowData?.vouchersnapshot?.status !== "USED" && 
          <span className={`send-icon ${rowData?.vouchersnapshot?.reserved ? "disabled" : ""}`}
            title="Share Voucher Code" 
            onClick={() => { setShareVoucher(true); setVoucherCode({code : formatPromoCode(rowData?.vouchersnapshot?.promoCode), id: rowData?.vouchersnapshot?.id }) }}>
          </span>
        }
      </div>
    );
  };

  const { mutate: reserveBatch } = useMutation(
    ({ payload }) => getBatchStatus(payload),
    {
      onSuccess: (response, variables) => {
        if (response === "success") {
          const { reserved, disabled } = variables.payload.voucherUpdate;
          const actionType = variables.actionType;
          let detail = "";
          if (actionType === "reserve") {
            detail = `Batch successfully ${reserved ? "reserved" : "unreserved"
              }.`;
          } else if (actionType === "disable") {
            detail = `Batch successfully ${disabled ? "disabled" : "enabled"}.`;
          }
          toast.current?.show({
            severity: "success",
            summary: "Success",
            detail,
          });
          getBatch();
          setDisable(false);
          setShowBatchInfoDialog(false)
        } else {
          toast.current?.show({
            severity: "error",
            summary: "Error",
            life: globalConfig?.errorToastDisplayTime,
            detail:
              response?.error?.errorMsg || "Failed to update reserve status.",
          });
        }
      },
      onError: (error) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          life: globalConfig?.errorToastDisplayTime,
          detail:
            error?.message || "An error occurred while reserving the batch.",
        });
      },
    }
  );

  const { mutate: reserveVoucher } = useMutation(getVoucherStatus, {
    onSuccess: (response, variables) => {
      if (response === "success") {
        const { id, payload } = variables;
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: `Voucher ${variables.payload.reserved ? "reserved and copied" : "unreserved"} successfully`,
        });
        setVouchers((prev) =>
          prev.map((voucherGroup) => {
            const updatedVouchers = voucherGroup?.vouchers.map((v) => {
              if (v?.vouchersnapshot?.id === id) {
                return {
                  ...v,
                  vouchersnapshot: {
                    ...v.vouchersnapshot,
                    reserved: payload.reserved ? 1 : 0,
                    disabled: payload.disabled,
                    status: payload.reserved ? "RESERVED" : "Active",
                  },
                };
              }
              return v;
            });

            return {
              ...voucherGroup,
              vouchers: updatedVouchers,
            };
          })
        );
      } else {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          life: globalConfig?.errorToastDisplayTime,
          detail:
            response?.error?.errorMsg || "Failed to update reserve status.",
        });
      }
    },
    onError: (error) => {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        life: globalConfig?.errorToastDisplayTime,
        detail:
          error?.message || "An error occurred while reserving the batch.",
      });
    },
  });

  const handleReserveBatch = (rowData, actionType, screen) => {
    let batchId = "";
    if (actionType === "reserve" || screen === "main") {
      batchId = rowData?.batchName;
    } else if (actionType === "disable" && screen !== "main") {
      batchId = rowData?.name;
    }

    const voucherUpdate = {
      note: "",
    };

    if (actionType === "reserve") {
      voucherUpdate.reserved = rowData?.reserved === rowData?.total ? false : true;
    }

    if (actionType === "disable") {
      voucherUpdate.disabled = !rowData?.disabled;
    }

    const payload = {
      voucherUpdate,
      batchId,
    };

    reserveBatch({ payload, actionType });
  };

  const handleReserveVoucher = (rowData, actionType) => {
    const isDisabling = actionType === "disable";
    const isReserving = actionType === "reserve";
    const id = rowData?.vouchersnapshot?.id;
    const payload = {
      reserved: isReserving
        ? !rowData?.vouchersnapshot?.reserved
        : rowData?.vouchersnapshot?.reserved,
      disabled: isDisabling
        ? !rowData?.vouchersnapshot?.disabled
        : rowData?.vouchersnapshot?.disabled,
      note: "",
    };
    reserveVoucher({ id, payload });
  };

  const rowExpansionTemplate = (rowData) => {
    const batchRow = vouchers?.find((b) => b?.batchName === rowData?.batchName);
    const renderVoucherStatus = (voucher) => {
      const voucherStatus = voucher?.vouchersnapshot?.status;
      if (!voucherStatus || voucherStatus?.length === 0) {
        return <span className="status expired">N/A</span>; // Handle cases where there are no vouchers
      }
      switch (voucherStatus.toLowerCase()) {
        case "published":
          return <span className="status published">Published</span>;
        case "active":
          return <span className="status active">Active</span>;
        case "reserved":
          return <span className="status pending">Reserved</span>;
        case "pending":
          return <span className="status pending">Pending</span>;
        case "expired":
          return <span className="status expired">Expired</span>;
        case "used":
          return <span className="status redeemed">Redeemed</span>;
        case "invalid":
          return <span className="status expired">Invalid</span>;
        default:
          return <span className="status none">Unknown Status</span>;
      }
    };

    return (
      <div className="expanded-table">
        {batchRow?.vouchers && batchRow.vouchers?.length > 0 ? (
          <PR.DataTable
            value={batchRow?.vouchers}
            stripedRows
            className="vouchers-expandable-table"
            emptyMessage={<span className="text-gray-500">{affiliate?.AFFNL0076 || "No results found"}</span>}
            rowClassName={(rowData) => {
              let className = "";
              if (rowData?.vouchersnapshot?.disabled === true) {
                className += "disabled-row ";
              }
              return className.trim();
            }}
          >
            {/* Render shared bundle details */}
            <PR.Column header="" style={{ width: "3.3%" }} />
            <PR.Column
              header=""
              style={{ width: "16%", borderRight: "1px solid #C2C7D2" }}
              className="batch-column"
            />
            <PR.Column
              header="Plan"
              body={(e) =>
                e?.description ? filterCountryName(e?.description) : "-"
              }
              style={{ width: "12%" }}
            />
            <PR.Column
              header="Duration"
              body={(e) => (e.duration ? `${e.duration} days` : "-")}
              style={{ width: "9%" }}
            />
            <PR.Column
              header="Data"
              body={(e) => setDataAmount(e)}
              style={{ width: "8%" }}
            />
            <PR.Column
              header="Price"
              body={(e) => (e.ourPrice ? `${getCurrencySymbol()}${e.ourPrice}` : "-")}
              style={{ width: "8%" }}
            />

            <PR.Column
              header="Status"
              body={(voucher) => renderVoucherStatus(voucher)}
              style={{ width: "10%" }}
            />
            <PR.Column
              header="Voucher Code"
              className="voucherCode"
              field="promoCode"
              body={(rowData) => {
                let disableCode =
                  rowData?.vouchersnapshot?.status === "RESERVED";
                return (
                  <div className="voucherCode">
                    {disableCode ? (
                      <span>XXXX-XXXX-XXXX</span>
                    ) : (
                      <span>
                        {formatPromoCode(rowData?.vouchersnapshot?.promoCode) ||
                          "N/A"}
                      </span>
                    )}
                  </div>
                );
              }}
              style={{ width: "13%" }}
            />
            {seeUsers && 
            <PR.Column
              header="Redeemed by"
              body={(voucher) => {
                const redeemed = voucher?.vouchersnapshot?.redeemedBy;
                return Array.isArray(redeemed) && redeemed.length > 0 ? redeemed[0] : "-";
              }}
              style={{ width: "12%" }}
            />
            }
            <PR.Column
              body={expandAction}
              header="Action"
              className="last-column"
              style={{ width: "8%" }}
            ></PR.Column>
          </PR.DataTable>
        ) : (
          <p className="no-vouchers-p-tag">No additional vouchers</p>
        )}
      </div>
    );
  };

  const { refetch: getBatch, isLoading: getBatchLoading } = useQuery(
    ["BATCH_LIST", afUserData?.afId, offset],
    () => {
      const defaultFilters = {
        offset: offset,
        limit: itemsPerPage + 1,
        orderBy: sortField,
        direction: sortOrder,
      };

      const queryParams = serializeParams({
        ...filters,
        ...defaultFilters,
      });

      return getBatchList(queryParams);
    },
    {
      retry: 1,
      staleTime: 10000 * 50,
      onSuccess: (response) => {
        const promoCodes = Array.isArray(response)
          ? response
          : response.data ?? [];
        const promoCodesList = promoCodes.filter(
          (p) => p.name !== "" && p.bundles.length !== 0
        );
        if (promoCodes.length === itemsPerPage + 1) {
          setTotalRecords(offset + itemsPerPage + 1);
        } else {
          setTotalRecords(offset + promoCodes.length);
        }
        setPrepaidList(promoCodes?.slice(0, 10));
        if (!serializeParams(filters).includes("batchId")) {
          const batchOptions = promoCodesList.map((item) => ({
            name: item.name,
            value: item.name,
          }));
          setBatchOptions(batchOptions);
        }
      },
      onError: (error) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          life: globalConfig?.errorToastDisplayTime,
          detail: error?.message || "An error occurred",
        });
        setPrepaidList([]);
      },
    }
  );

  useEffect(() => {
    getBatch();
  }, [filters, offset, sortField, sortOrder, getBatch]);

  const {
    data: batchInfoData,
    refetch: fetchBatchInfo,
    isLoading: batchInfoLoading,
  } = useQuery({
    queryKey: ["batchInfo"],
    queryFn: () => getBatchInfo(latestReqRef.current),
    enabled: false,
    retry: 1,
    onSuccess: (response) => {
      setShowBatchInfoDialog(true);
      setDisableText(
        response?.data?.vouchers?.[0]?.vouchersnapshot?.disabled === true
          ? "Enable Batch"
          : "Disable Batch"
      );
    },
    onError: (error) => {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        life: globalConfig?.errorToastDisplayTime,
        detail:
          error?.message || "Something went wrong while fetching batch info.",
      });
    },
  });

  const handleBatchInfoClick = async (rowData) => {
    if (
      !rowData?.batchName ||
      !rowData?.vouchers?.[0]?.vouchersnapshot?.status
    ) {
      toast.current?.show({
        severity: "warn",
        summary: "Missing data",
        detail: "Batch name or status is missing in the selected row.",
      });
      return;
    }

    latestReqRef.current = {
      id: rowData.batchName,
    };
    await fetchBatchInfo();
  };

  const { mutate, isLoading } = useMutation({
    mutationFn: ({ email, id }) => shareEmail(email, id),
    onSuccess: (_, { id }) => {
      toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Voucher shared successfully!' });
      setShareVoucher(false);
      setEmail("");
      setEmailError("");
      setVouchers((prev) =>
        prev.map(({ vouchers, ...group }) => ({
          ...group,
          vouchers: vouchers.map((v) =>
            v?.vouchersnapshot?.id === id
              ? {
                  ...v,
                  vouchersnapshot: {
                    ...v.vouchersnapshot,
                    reserved: 1 ,
                    status: "RESERVED",
                  },
                }
              : v
          ),
        }))
      );
      
    },
    onError: (error) => {
      toast.current?.show({ severity: 'error', summary: 'Error', life: globalConfig?.errorToastDisplayTime, detail: error?.message || 'Failed to share voucher.' });
    }
  });

  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!value.trim()) {
      return "Email is required.";
    } else if (!emailRegex.test(value)) {
      return "Please enter a valid email.";
    }
    return "";
  };

  const handleSend = () => {
    const error = validateEmail(email);
    if (error) {
      setEmailError(error);
      return;
    }

    setEmailError("");
    mutate({ email, id: voucherCode?.id });
  };

  const handleHide = () => {
    setShareVoucher(false);
    setEmail("");
    setEmailError("");
  };

  const handleBlur = () => {
    const error = validateEmail(email);
    setEmailError(error);
  };

  const handleReset = () => {
    setEmail("");
    setEmailError("");
  };

  useQuery(["COUNTRIES_LIST"], () => getCountries(), {
    cacheTime: 0,
    staleTime: 0,
    refetchOnWindowFocus: false,
    onSuccess: (response) => {
      const countriesData = response.data || [];
      if (countriesData.length > 0) {
        const countriesList = countriesData.map(({ name, region, iso }) => ({
          name: name.split("(")[0].trim(),
          region,
          iso,
        }));

        setAllCountries(countriesList);
        setFilterCountries(countriesList);
        const uniqueRegionList = [
          ...new Set(countriesList.map((item) => item.region)),
        ].map((region) => ({ label: region, value: region }));

        const unemptyRegionList = uniqueRegionList
          .filter((region) => region.label && region.value)
          .sort((a, b) => a.label.localeCompare(b.label));

        setUniqueRegions(unemptyRegionList);
      }
    },
    onError: (error) => {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        life: globalConfig?.errorToastDisplayTime,
        detail: error?.message || "Failed to fetch countries",
      });
    },
  });

  const handleExportCSV = (rowData) => {
    if (!rowData?.vouchers || rowData?.vouchers?.length === 0) {
      toast.current?.show({
        severity: "warn",
        summary: "Warning",
        detail: "No vouchers available to export",
      });
      return;
    }

    const vouchers = rowData.vouchers.map((voucher) => ({
      BatchName: rowData?.batchName,
      Description: voucher?.description ? voucher?.description : "-",
      BundleID: voucher?.providerid ? voucher?.providerid : "-",
      Data: setDataAmount(voucher),
      Duration: voucher?.duration ? `${voucher?.duration} days` : "-",
      Price: voucher?.ourPrice
        ? `${getCurrencySymbol()} ${voucher?.ourPrice}`
        : "-",
      Provider: voucher?.providerName ? voucher?.providerName : "-",
      Status:
        voucher?.vouchersnapshot?.status === "USED"
          ? "REDEEMED"
          : voucher?.vouchersnapshot?.status,
      VoucherCode: formatPromoCode(voucher?.vouchersnapshot?.promoCode),
      RedeemedBy: 
        Array.isArray(voucher?.vouchersnapshot?.redeemedBy) && 
          voucher.vouchersnapshot.redeemedBy[0]
            ? voucher.vouchersnapshot.redeemedBy[0].trim()
            : "-"
      }));

    if (vouchers.length > 0) {
      const csvContent =
        "data:text/csv;charset=utf-8," +
        [
          "Batch Name",
          "Description",
          "Bundle ID",
          "Data",
          "Duration",
          "Price",
          "Provider",
          "Status",
          "Voucher Code",
          "Redeemed By",
        ].join(",") +
        "\n" +
        vouchers
          .map((entry) =>
            Object.values(entry)
              .map((value) =>
                typeof value === "string" && value.includes(",")
                  ? `"${value}"`
                  : value
              )
              .join(",")
          )
          .join("\n");

      const encodedUri = encodeURI(csvContent);

      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute(
        "download",
        `affiliate-prepaid-vouchers-${rowData?.batchName}-${timeStamp}.csv`
      );
      document.body.appendChild(link);
      link.click();
    }
  };

  const downloadXls = (batch) => {
    const mappedBatch = {
      batchName: batch?.name,
      vouchers: batch.bundles.flatMap((allBundle) =>
        allBundle.vouchers.length > 0
          ? allBundle.vouchers.map((voucher) => ({
            description: allBundle?.bundle?.description,
            providerid: allBundle?.bundle?.providerid,
            dataAmount: allBundle?.bundle?.dataAmount,
            duration: allBundle?.bundle?.duration,
            ourPrice: allBundle?.bundle?.ourPrice,
            providerName: allBundle?.providerName,
            vouchersnapshot: {
              promoCode: voucher?.vouchersnapshot?.promoCode,
              status: voucher?.vouchersnapshot?.status,
              redeemedBy: voucher?.vouchersnapshot?.redeemedBy,
            },
          }))
          : [
            {
              description: allBundle?.bundle?.description,
              providerid: allBundle?.bundle?.providerid,
              dataAmount: allBundle?.bundle?.dataAmount,
              duration: allBundle?.bundle?.duration,
              ourPrice: allBundle?.bundle?.ourPrice,
              providerName: allBundle?.providerName,
              vouchersnapshot: {
                promoCode: "-",
                status: "-",
                redeemedBy: "-"
              },
            },
          ]
      ),
    };

    handleExportCSV(mappedBatch);
  };

  const onSortChange = (field) => {
    const newSortOrder =
      sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(newSortOrder);
    setExpandedRows([]);
  };

  const renderSortableHeader = (label, field) => {
    return (
      <div onClick={() => onSortChange(field)}>
        {label}
        <i
          className={`pi pi-sort-${sortField === field
            ? sortOrder === "asc"
              ? "amount-up-alt"
              : "amount-down"
            : "alt"
            }`}
          style={{ marginLeft: "0.5rem" }}
        />
      </div>
    );
  };

  const regionFilterHandler = (region) => {
    setFilterSelectedRegion(region);
    const countriesByRegion = region
      ? allCountries?.filter((c) => c.region === region)
      : allCountries;
    const countryDisplay = countriesByRegion?.find(
      (c) => c.iso === filterCountry
    )
      ? filterCountry
      : null;
    setFilterCountry(region ? countryDisplay : "GB");
    setFilterCountries(countriesByRegion);
  };

  const countryFilterHandler = (e) => {
    setFilterCountry(e.value);
  };

  const handleFilterReset = () => {
    setFilterSelectedRegion(null);
    setFilterCountries(allCountries);
    setFilterCountry("GB");
    setFilterBatchName(null);
    setFilterStatus("");
    setFilterProvider("");
    setStartDate(null);
    setEndDate(null);
    setFilterCount(0);
    setFilterApplyStatus(false)
    setFilterVisible(false);
    if (filterApplyStatus) {
      setFilters(state => ({
        ...state,
        region: "",
        country: "",
        provider: "",
        batchId: null,
        status: "",
        keyword: "",
        createdTimeStart: null,
        createdTimeEnd: null,
        redeemTimeStart: null,
        redeemTimeEnd: null
      }))
    }
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    setFilterVisible(false);
    const createdTimeStart =
      Array.isArray(startDate) && startDate[0]
        ? moment(startDate[0]).format("DD-MM-YYYY")
        : null;

    const createdTimeEnd =
      Array.isArray(startDate) && (startDate[1] || startDate[0])
        ? moment(startDate[1] || startDate[0]).format("DD-MM-YYYY")
        : null;

    const redeemTimeStart =
      Array.isArray(endDate) && endDate[0]
        ? moment(endDate[0]).format("DD-MM-YYYY")
        : null;

    const redeemTimeEnd =
      Array.isArray(endDate) && (endDate[1] || endDate[0])
        ? moment(endDate[1] || endDate[0]).format("DD-MM-YYYY")
        : null;
    const newFilters = {
      region: filterSelectedRegion,
      country: filterCountry,
      provider: filterprovider
        ? filterprovider.map((provider) => provider.name).join(",")
        : "",
      batchId: filterBatchName,
      createdTimeStart,
      createdTimeEnd,
      redeemTimeStart,
      redeemTimeEnd,
      status: filterStatus,
    };
    setOffset(0);
    setFirst(0);
    setRows(10);
    setFilterApplyStatus(true)
    setFilters((prev) => ({ ...prev, ...newFilters }));
    setFilterCount(getAppliedFiltersCount());
  };

  const getAppliedFiltersCount = () => {
    let count = 0;

    if (Array.isArray(filterprovider) && filterprovider.length > 0) {
      count += filterprovider.length;
    }
    if (filterSelectedRegion) count++;
    if (filterCountry) count++;
    if (filterBatchName) count++;
    if (startDate) count++;
    if (endDate) count++;
    if (filterStatus) count++;

    return count;
  };

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
    setOffset(event.first)
  };
  const getBatchHandler = () => {
    setOffset(0);
    setFirst(0);
    setRows(10);
    getBatch()
  }

  return (
    <>
      <PR.Toast ref={toast} />
      <section className="prepaid-vouchers relative">
        <div className="grid grid-nogutter">
          <div className="col-12">
            <div className="heading-sec vouchers-header">
              <div className="flex align-items-center justify-content-between mb-4 mobile-flex">
                <div className="flex align-items-center justify-content-between">
                  <div className="right-section flex align-items-center gap-3">
                    {createVoucherPermission &&
                      <PR.Button
                        label={affiliate?.AFFNL0086 || "Create Prepaid Voucher"}
                        className="create-button"
                        icon="pi pi-plus"
                        iconPos="left"
                        onClick={() => setVisible(true)}
                      />
                    }
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-content-between filter-block vouchers-filter-block">
              <div className="flex align-items-center gap-2">
                <span className="p-input-icon-right search-field">
                  <i className="pi pi-search" />
                  <PR.InputText
                    name={affiliate?.AFFNL0087 || "search"}
                    placeholder={seeUsers ? "Search by voucher code or redeemed email" : "Search by voucher code"}
                    value={searchValue.trim()}
                    onChange={(e) => setSearchValue(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        getSearchHandler();
                      }
                    }}
                    disabled={getBatchLoading}
                  />
                </span>
                <PR.Dropdown
                  filter
                  placeholder={affiliate?.AFFNL0088 || "Batch Name"}
                  value={getBatchName}
                  options={batchOptions}
                  onChange={(e) => setGetBatchName(e.value)}
                  resetFilterOnHide
                  optionLabel="name"
                  optionValue="value"
                  name="batchName"
                  disabled={getBatchLoading}
                />
                <PR.MultiSelect
                  placeholder={affiliate?.AFFNL0089 || "Status"}
                  value={getStatus}
                  options={optionStatusList}
                  onChange={(e) => setGetStatus(e.value)}
                  optionLabel="label"
                  optionValue="value"
                  name="status"
                  maxSelectedLabels={1}
                  disabled={getBatchLoading}
                />
                <PR.Button
                  type="submit"
                  label={affiliate?.AFFNL0090 || "Search"}
                  className="filter-buttons"
                  onClick={getSearchHandler}
                  disabled={(getStatus?.length === 0 && getBatchName?.length === 0 && !searchValue) || getBatchLoading}
                />
                <PR.Button
                  type="reset"
                  label={affiliate?.AFFNL0083 || "Reset"}
                  className="filter-buttons reset-button"
                  onClick={getResetHandler}
                  disabled={getBatchLoading}
                />
              </div>
              <PR.Button
                label={filterCount > 0 ? <>{affiliate?.AFFNL0091 || "Filter"} <span className="count">{filterCount}</span></> : affiliate?.AFFNL0091 || "Filter"}
                className="filter-buttons filter-icon"
                icon="pi pi-filter"
                onClick={() => setFilterVisible(true)}
                disabled={getBatchLoading}
              />
            </div>
          </div>
        </div>
        <div className="card mt-4">
          <PR.DataTable
            value={flattenedList}
            expandedRows={expandedRows}
            loading={getBatchLoading}
            onSort={onSortChange}
            emptyMessage={<span className="text-gray-500">{affiliate?.AFFNL0076 || "No results found"}</span>}
            onRowToggle={(e) => {
              const validExpandedRows = e.data?.filter(
                (rowData) => !rowData?.vouchers[0]?.vouchersnapshot?.disabled
              );
              setExpandedRows(validExpandedRows);
            }}
            rowExpansionTemplate={rowExpansionTemplate}
            globalFilterFields={["batchName", "promoCode"]}
            // dataKey="id"
            className="sales-datatable prepaid-vouchers-table"
            onRowClick={(e) => {
              const rowData = e.data;
              if (!rowData?.vouchers[0]?.vouchersnapshot?.disabled) {
                setExpandedRows((prevExpandedRows) => {
                  const isAlreadyExpanded = prevExpandedRows?.some(
                    (row) => row?.batchName === rowData?.batchName
                  );

                  return isAlreadyExpanded
                    ? prevExpandedRows.filter(
                      (row) => row?.batchName !== rowData?.batchName
                    )
                    : [...prevExpandedRows, rowData];
                });
              }
            }}
          >
            <PR.Column
              expander
              style={{ width: "3.3%", padding: "20px 5px" }}
            />
            <PR.Column
              field="name"
              body={batchName}
              header={renderSortableHeader(affiliate?.AFFNL0092 || "Batch Name", "batchName")}
              style={{ width: "16%", borderRight: "1px solid #C2C7D2" }}
            ></PR.Column>
            <PR.Column
              header={renderSortableHeader("Plan", "description")}
              style={{ width: "12%" }}
              body={(rowData) => {
                const isRowExpanded = expandedRows?.some(
                  (row) => row?.batchName === rowData?.batchName
                ); // Check if the row is expanded
                if (!rowData?.vouchers[0]?.vouchersnapshot?.disabled) {
                  return (
                    <p className="batch-p">
                      <strong>{`${rowData?.redeemed}/${rowData?.total} Vouchers redeemed`}</strong>
                      {!isRowExpanded && (
                        <span className="click-info">
                          ({affiliate?.AFFNL0093 || "Click to expand the detail view of the batch"})
                        </span>
                      )}
                    </p>
                  );
                } else {
                  return (
                    <span className="batch-p">
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          setDisableText("Enable Batch");
                          setBatchData(rowData);
                          setDisable(true);
                        }}
                        style={{
                          color: "#0E0020",
                          textDecoration: "underline",
                          cursor: "pointer",
                          border: "none",
                          background: "none"
                        }}
                      >
                        {affiliate?.AFFNL0095 || "Batch Disabled"}
                      </button>
                    </span>
                  );
                }
              }}
            ></PR.Column>
            <PR.Column
              header={renderSortableHeader(affiliate?.AFFNL0096 || "Duration", "duration")}
              style={{ width: "9%" }}
            ></PR.Column>
            <PR.Column
              header={renderSortableHeader(affiliate?.AFFNL0079 || "Data", "dataAmount")}
              style={{ width: "8%" }}
            ></PR.Column>
            <PR.Column
              header={renderSortableHeader(affiliate?.AFFNL0081 || "Price", "ourPrice")}
              style={{ width: "8%" }}
            ></PR.Column>
            <PR.Column
              header={renderSortableHeader(affiliate?.AFFNL0089 || "Status", "status")}
              style={{ width: "10%" }}
            ></PR.Column>
            <PR.Column
              header={renderSortableHeader(affiliate?.AFFNL0098 || "Voucher Code", "promoCode")}
              style={{ width: "13%" }}
            ></PR.Column>
            {seeUsers && 
            <PR.Column
              header={(affiliate?.AFFNL0142 || "Redeemed by")}
              style={{ width: "12%" }}
            ></PR.Column>
            }
            <PR.Column
              body={action}
              header={affiliate?.AFFNL0099 || "Action"}
              className="last-column"
              headerClassName="action"
              style={{ width: "8%" }}
            ></PR.Column>
          </PR.DataTable>

          <PR.Paginator className="vouchers-pagination" first={first} rows={rows} totalRecords={totalRecords} onPageChange={onPageChange} />

          <PR.Dialog
            visible={disable}
            dismissableMask={true}
            draggable={false}
            resizable={false}
            header={
              disableText === "Disable Batch" ? affiliate?.AFFNL0100 || "Disable Batch" : affiliate?.AFFNL0101 || "Enable Batch"
            }
            onHide={() => setDisable(false)}
            className="create-voucher-dailog disable-batch"
            maskClassName="affiliate-dialog-mask"
          >
            <p>
              {affiliate?.AFFNL0102 || "Are you sure you want to"}{" "}
              {disableText === "Disable Batch" ? affiliate?.AFFNL0104 || "Disable" : affiliate?.AFFNL0105 || "Enable"} {affiliate?.AFFNL0103 || "this batch?"}
            </p>
            <div className="col-12 flex align-items-center justify-content-end gap-3 mt-5 custom-min-width w-12">
              <PR.Button
                onClick={() => setDisable(false)}
                label={affiliate?.AFFNL0106 || "No"}
                className="Search-button"
                disabled={batchInfoLoading}
              />
              <PR.Button
                onClick={() => handleReserveBatch(batchData, "disable", "main")}
                label={affiliate?.AFFNL0107 || "Yes"}
                className="Search-button disable-batch"
                disabled={batchInfoLoading}
              />
            </div>
          </PR.Dialog>
        </div>
      </section>
      <CreatePrepaidVoucher
        allCountries={allCountries}
        uniqueRegions={uniqueRegions}
        visible={visible}
        setVisible={setVisible}
        toast={toast}
        getBatch={getBatchHandler}
      />

      {/* Filter Dailog code */}
      <PR.Dialog
        header={affiliate?.AFFNL0108 || "Filter"}
        visible={filterVisible}
        draggable={false}
        blockScroll={true}
        onHide={() => {
          if (!filterVisible) return;
          setFilterVisible(false);
        }}
        className="create-voucher-dailog"
      >
        <form autoComplete="off" className="mt-0" onSubmit={handleFilterSubmit}>
          <div className="grid">
            <div className="col-12 pb-1">
              <label htmlFor="username">{affiliate?.AFFNL0109 || "By region or country or provider"}</label>
            </div>
            <div className="col-12 md:col-6">
              <PR.Dropdown
                value={filterSelectedRegion}
                onChange={(e) => regionFilterHandler(e.value)}
                options={uniqueRegions}
                optionLabel="label"
                placeholder={affiliate?.AFFNL0072 || "Select region"}
                filter
                resetFilterOnHide
                showClear="true"
                className="w-full"
              />
            </div>
            <div className="col-12 md:col-6">
              <PR.Dropdown
                value={filterCountry}
                onChange={countryFilterHandler}
                options={filterCountries}
                optionLabel="name"
                optionValue="iso"
                placeholder={affiliate?.AFFNL0073 || "Select country"}
                showClear="true"
                filter
                resetFilterOnHide
                className="w-full"
              />
            </div>
            {/* <div className="col-12 md:col-4">
              <PR.MultiSelect
                value={filterprovider}
                onChange={handleProviderFilterSelection}
                options={providerList}
                optionLabel="name"
                placeholder={affiliate?.AFFNL0110 ||"Select provider"}
                className="w-full"
              />
            </div> */}
          </div>
          <div className="grid mt-3">
            <div className="col-12 pb-1">
              <label htmlFor="username">{affiliate?.AFFNL0111 || "By batch name or created date"}</label>
            </div>
            <div className="col-12 md:col-6">
              <PR.Dropdown
                value={filterBatchName}
                onChange={(e) => {
                  setFilterBatchName(e.value);
                }}
                options={batchOptions}
                showClear={true}
                resetFilterOnHide
                optionLabel="name"
                placeholder={affiliate?.AFFNL0112 || "Select batch"}
                filter
                className="w-full"
              />
            </div>
            <div className="col-12 md:col-6">
              <PR.Calendar
                value={startDate}
                onChange={(e) => setStartDate(e.value)}
                selectionMode="range"
                dateFormat="dd/mm/yy"
                showIcon
                placeholder={affiliate?.AFFNL0113 || "Select date"}
                maxDate={new Date()}
              />
            </div>
          </div>
          <div className="grid mt-3">
            <div className="col-12 pb-1">
              <label htmlFor="username">{affiliate?.AFFNL0114 || "Voucher status or date redeemed"}</label>
            </div>
            <div className="col-12 md:col-6">
              <PR.MultiSelect
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.value)}
                options={optionStatusList}
                optionLabel="label"
                placeholder={affiliate?.AFFNL0115 || "Select status"}
                filter
                className="w-full"
              />
            </div>
            <div className="col-12 md:col-6">
              <PR.Calendar
                value={endDate}
                onChange={(e) => setEndDate(e.value)}
                selectionMode="range"
                dateFormat="dd/mm/yy"
                showIcon
                placeholder={affiliate?.AFFNL0113 || "Select date"}
                maxDate={new Date()}
              />
            </div>
          </div>
          <div className="col-12 flex gap-3 align-items-center justify-content-end mt-3">
            <PR.Button
              type={"reset"}
              label={affiliate?.AFFNL0051 || "Reset"}
              className="Search-button reset"
              onClick={handleFilterReset}
            />
            <PR.Button label={affiliate?.AFFNL0116 || "Apply"} className="Search-button create" />
          </div>
        </form>
      </PR.Dialog>

      {/* Info Dialog code */}
      <PR.Dialog
        header={affiliate?.AFFNL0117 || "Prepaid Voucher Details"}
        visible={showBatchInfoDialog}
        draggable={false}
        resizable={false}
        blockScroll={true}
        onHide={() => setShowBatchInfoDialog(false)}
        dismissableMask={true}
        maskClassName="create-voucher-dialog-mask"
        className="create-voucher-dailog"
      >
        <>
          {(batchInfoData?.length ? batchInfoData : [{}]).map(
            (
              batch = {},
              index // Iterate through each batch
            ) => (
              <div key={index}>
                <div className="grid">
                  <div className="col-12 md:col-6">
                    <p className="mb-2">{affiliate?.AFFNL0092 || "Batch Name"}</p>
                    <PR.InputText
                      value={batch.name || ""} // Accessing batch name
                      className="w-full"
                      name="batchName"
                      readOnly
                      disabled={batchInfoLoading}
                    />
                  </div>
                  <div className="col-12 md:col-6">
                    <p className="mb-2">{affiliate?.AFFNL0118 || "Voucher Count"}</p>
                    <PR.InputText
                      value={batch.total || ""} // Accessing total voucher count
                      className="w-full"
                      type="number"
                      name="voucherCount"
                      readOnly
                      disabled={batchInfoLoading}
                    />
                  </div>
                </div>

                <div className="grid mt-2">
                  <div className="col-12 pb-1">
                    <p className="m-0">{affiliate?.AFFNL0119 || "Bundle(s) Details"}</p>
                  </div>
                  <div className="col-12">
                    <PR.DataTable
                      value={batch.bundles ?? []} // Directly using the bundles array
                      className="bundles-datatable"
                      loading={batchInfoLoading}
                      emptyMessage={
                        <span className="text-gray-500">{affiliate?.AFFNL0076 || "No results found"}</span>
                      }
                    >
                      <PR.Column
                        header={affiliate?.AFFNL0120 || "Bundle Name"}
                        body={(rowData) => (
                          <div>
                            <div>
                              {rowData.bundle.name ? rowData.bundle.name : "-"}
                            </div>
                            <div style={{ marginTop: "4px" }}>
                              {rowData.bundle.groups
                                ? rowData.bundle.groups
                                : "-"}
                            </div>
                          </div>
                        )}
                      />
                      <PR.Column
                        field="bundle.dataAmount" // Accessing data amount for display
                        header={affiliate?.AFFNL0097 || "Data"}
                        sortable
                        body={(rowData) => setDataAmount(rowData?.bundle)}
                      />
                      <PR.Column
                        field="bundle.duration" // Accessing duration
                        header={affiliate?.AFFNL0096 || "Duration"}
                        body={(rowData) =>
                          rowData?.bundle.duration
                            ? `${rowData?.bundle.duration} days`
                            : "-"
                        }
                      />
                      <PR.Column
                        field="bundle.roamingEnabled" // Accessing roaming information
                        header={affiliate?.AFFNL0004 || "Roaming"}
                        body={(data) => <RoamingColumn data={data?.bundle} />}
                        style={{ width: "12%" }}
                      />
                      <PR.Column
                        field="bundle.price" // Accessing price
                        header={affiliate?.AFFNL0081 || "Price"}
                        sortable
                        body={(rowData) =>
                          rowData?.bundle.ourPrice
                            ? `${getCurrencySymbol()}${rowData?.bundle.ourPrice}`
                            : "-"
                        }
                      />
                      <PR.Column
                        field="vouchers" // Accessing vouchers for the count
                        body={(data) => data.vouchers.length} // Displaying the number of vouchers
                        header={affiliate?.AFFNL0082 || "No. of vouchers"}
                        className="last-column"
                      />
                    </PR.DataTable>
                  </div>
                  <PR.Dialog
                    visible={disable}
                    dismissableMask={true}
                    draggable={false}
                    resizable={false}
                    header={
                      disableText === "Disable Batch"
                        ? affiliate?.AFFNL0100 || "Disable Batch"
                        : affiliate?.AFFNL0101 || "Enable Batch"
                    }
                    onHide={() => setDisable(false)}
                    className="create-voucher-dailog disable-batch"
                  >
                    <p>
                      {affiliate?.AFFNL0102 || "Are you sure you want to"}{" "}
                      {disableText === "Disable Batch" ? affiliate?.AFFNL0104 || "Disable" : affiliate?.AFFNL0105 || "Enable"}{" "}
                      {affiliate?.AFFNL0103 || "this batch?"}
                    </p>
                    <div className="col-12 flex align-items-center justify-content-end gap-3 mt-5 custom-min-width w-12">
                      <PR.Button
                        onClick={() => setDisable(false)}
                        label={affiliate?.AFFNL0106 || "No"}
                        className="Search-button"
                        disabled={batchInfoLoading}
                      />
                      <PR.Button
                        onClick={() =>
                          handleReserveBatch(batch, "disable", "info")
                        }
                        label={affiliate?.AFFNL0107 || "Yes"}
                        className="Search-button disable-batch"
                        disabled={batchInfoLoading}
                      />
                    </div>
                  </PR.Dialog>
                </div>

                <div className="col-12 flex align-items-center justify-content-between mt-3 m-flex">
                  <div><p>{affiliate?.AFFNL0121 || "Created date"}:{" "}
                    {moment
                      .utc(batch.createdAt)
                      .local()
                      .format("DD-MM-YY | HH:mm:ss")}</p>
                  </div>
                  <div className="flex align-items-center justify-content-end custom-min-width gap-2">
                    <PR.Button
                      label={affiliate?.AFFNL0122 || "Download CSV"}
                      type="button"
                      className="Search-button"
                      onClick={() => downloadXls(batch)}
                      disabled={disableText === "Enable Batch" || batch.total < 1}
                    />
                    {createVoucherPermission &&
                      <PR.Button
                        label={disableText === "Disable Batch"
                          ? affiliate?.AFFNL0100 || "Disable Batch"
                          : affiliate?.AFFNL0101 || "Enable Batch"
                        }
                        type="button"
                        className="Search-button disable-batch"
                        onClick={() => setDisable(true)}
                      />
                    }
                  </div>
                </div>

              </div>
            )
          )}
        </>
      </PR.Dialog>

      {/* Share Voucher Code Modal Dialog */}
      <PR.Dialog header="Share Voucher Code" visible={shareVoucher} onHide={handleHide} maskClassName="create-voucher-dialog-mask"
        className="create-voucher-dailog voucher-code-dailog" draggable={false} resizable={false} blockScroll={true}>
        <div className="voucher-code-content">
          <h2>{voucherCode?.code}</h2>
          <div className="grid">
            <div className="col-12 md:col-12">
              <p className="mb-2">{affiliate?.AFFNL0143 || "Enter the email address you want to share the code"}</p>
              <PR.InputText
                className="w-full"
                name="email"
                value={email}
                onBlur={handleBlur}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="example@domain.com"
              />
              {emailError && <small className="p-error">{emailError}</small>}
            </div>
            <div className="col-12 flex gap-3 align-items-center justify-content-end mt-3">
              <PR.Button
                label="Reset"
                className="Search-button reset"
                onClick={handleReset}
                disabled={isLoading}
              />
              <PR.Button
                label="Send"
                className="Search-button create"
                onClick={handleSend}
                loading={isLoading}
              />
            </div>
          </div>
        </div>
      </PR.Dialog>
    </>
  );
};

export default PrepaidVouchers;
